import { InjectionToken } from '@angular/core';

export const SHARED_API_BASE_PATH = new InjectionToken<string>('basePath');
export const SHARED_API_COLLECTION_FORMATS = {
    'csv': ',',
    'tsv': '   ',
    'ssv': ' ',
    'pipes': '|'
}

export const BILL_API_BASE_PATH = new InjectionToken<string>('basePath');
export const BILL_API_COLLECTION_FORMATS = {
    'csv': ',',
    'tsv': '   ',
    'ssv': ' ',
    'pipes': '|'
}

export const EEC_API_BASE_PATH = new InjectionToken<string>('basePath');
export const EEC_API_COLLECTION_FORMATS = {
    'csv': ',',
    'tsv': '   ',
    'ssv': ' ',
    'pipes': '|'
}

export const FF_API_BASE_PATH = new InjectionToken<string>('basePath');
export const FF_API_COLLECTION_FORMATS = {
    'csv': ',',
    'tsv': '   ',
    'ssv': ' ',
    'pipes': '|'
}

export const PROV_API_BASE_PATH = new InjectionToken<string>('basePath');
export const PROV_API_COLLECTION_FORMATS = {
    'csv': ',',
    'tsv': '   ',
    'ssv': ' ',
    'pipes': '|'
}